<h2 mat-dialog-title>Documentación adjunta</h2>

<mat-dialog-content>
  <ng-container *ngIf="loading; else content">
    <mat-progress-spinner mode="indeterminate" diameter="40" style="margin: auto;"></mat-progress-spinner>
  </ng-container>

  <ng-template #content>
    <ng-container *ngIf="attachments.length > 0; else emptyState">
      <mat-list>
        <mat-list-item
          *ngFor="let attachment of attachments"
          data-testid="attachment-item">
          <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; padding: 8px 0;">
            <div>
              <strong>{{ attachment.fileName }}</strong>
              <div style="font-size: 0.8em; color: grey;">
                {{ attachment.fileSize | number }} bytes · {{ attachment.uploadedAt | date:'short' }}
              </div>
            </div>
            <div style="display: flex; align-items: center; gap: 4px;">
              <a [href]="attachment.downloadUrl" target="_blank" mat-button color="primary" download>
                Descargar
              </a>
              <button mat-icon-button color="warn"
                (click)="deleteAttachment(attachment)"
                [attr.data-testid]="'delete-' + attachment.id">
                <mat-icon svgIcon="delete"></mat-icon>
              </button>
            </div>
          </div>
        </mat-list-item>
      </mat-list>
    </ng-container>

    <ng-template #emptyState>
      <p data-testid="empty-state" style="text-align: center; color: grey; padding: 24px 0;">
        No hay documentación adjunta para esta guardia.
      </p>
    </ng-template>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cerrar</button>
</mat-dialog-actions>
